import config from '../../config/config.json';

/* eslint-disable no-undef */
var libvue = {
  methods: {
    aaaaccess(user) {
      if (user && user.attributes) {
        return user.attributes.aaaaccess;
      }
      return false;
    },
    bce(ce) {
      return ce <= config.beginningMs*1e6;
    },
    smallStr(v, n) {
      if (v && n && v.length > n && n > 3) {
        return v.slice(0, n-3) + "...";
      }
      return v
    },
    idFromKey(v) {
      if (v) return v.slice(20);
      return v;
    },
    smallKey(v) {
      if (v) return v.split('-')[1];
      return v;
    },
    smallId(id) {
      if (id) return id.slice(0, 8);
      return id;
    },
    authMethod(sub) {
      if (sub) return sub.split('|')[0];
      return sub;
    },
    inTags(tags, tag) {
      var rc = false;
      if (tags) {
        tags.forEach((r) => {
          if (r == tag) {
            rc = true;
          }
        });
      }
      return rc;
    },
    prettyBool(v) {
      if (v) return "True";
      return "False";
    },
    prettyList(v) {
      var list = "";
      if (v) {
        v.forEach((vv) => {
          list += vv + " ";
        });
      }
      return list.trim();
    },
    prettyBytes(bytes) {
      if (bytes === 0) return '0 Bytes';
      var decimals = 2;
      var k = 1024;
      var dm = decimals < 0 ? 0 : decimals;
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    prettyPackages(v) {
      var packages = "";
      if (v) {
        v.forEach((r) => {
          packages += r + " ";
        });
      }
      return packages.trim();
    },
    dateToString(v) {
      if (v > 0) {
        return new Date(v / 1e6).toISOString().slice(0, -5)+'Z';
      }
      return '-';
    },
    dateToStringMs(v) {
      if (v > 0) {
        return new Date(v / 1e6).toISOString();
      }
      return '-';
    },
    dateToStringEmpty(v) {
      if (v > 0) {
        return new Date(v / 1e6).toISOString().slice(0, -5)+'Z';
      }
      return '';
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    deviceTypeToString(type) {
      switch (type) {
        case proto.pb.DeviceType.DEVICENONE:
          return "None";
        case proto.pb.DeviceType.DEVICEPAC:
          return "PAC";
        case proto.pb.DeviceType.DEVICESCADA:
          return "SCADA";
        default:
          return "UNKNOWN";
      }
    },
    deviceStringToType(string) {
      switch (string) {
        case "PAC":
          return proto.pb.DeviceType.DEVICEPAC;
        case "SCADA":
          return proto.pb.DeviceType.DEVICESCADA;
        default:
          return -1;
      }
    },
    imageStatus() {
      return proto.pb.Image.Status;
    },
    imageStatusToString(status) {
      switch (status) {
        case proto.pb.Image.Status.PENDING:
          return "PENDING";
        case proto.pb.Image.Status.RUNNING:
          return "RUNNING";
        case proto.pb.Image.Status.DONE:
          return "DONE";
        case proto.pb.Image.Status.FAILED:
          return "FAILED";
        case proto.pb.Image.Status.TIMEOUT:
            return "TIMEOUT";
        default:
          return "UNKNOWN";
      }
    },
    decodeCombinedOutput(v) {
      var str = ""
      if (v != "") {
        try {
          str = atob(v);
        } catch {
          str = v;
        }
      }
      return str;
    },
    filename(path) {
      var array = path.split("/");
      return array[array.length - 1];
    },
    errToString(err) {
      var message = "errCode: " + err.code;
      if (err.message) {
        message += " " + err.message;
      } else if (err.details) {
        message += " " + err.details;
      }
      return message;
    },
    getBucketName() {
      if (window.location.hostname.match("-dev") || window.location.hostname.match("localhost")) {
        return "imagemaker-dev";
      }
      return "imagemaker";
    },
  }
}

export default libvue;